__turbopack_context__.v({
  "className": "almarai_302e35f4-module__UVXO3G__className",
  "variable": "almarai_302e35f4-module__UVXO3G__variable",
});
